import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import PaginaDinamica from "../pages/PaginaDinamica";
import Sevac from "../pages/Sevac";
import CuentaPublica from "../pages/CuentaPublica";
import NewsDetail from "../pages/NewsDetail";
import NotFound from "../pages/NotFound";
import Organigrama from "../pages/Organigrama";
import Convocatorias from "../pages/Convocatorias";
import Manuales from "../pages/Manuales";

function AppRouter() {
  return (
    <Routes>
      {/* Página principal */}
      <Route path="/" element={<Home />} />

      {/* Rutas estáticas */}
      <Route path="/sevac" element={<Sevac />} />
      <Route path="/cuenta-publica" element={<CuentaPublica />} />
      <Route path="/organigrama" element={<Organigrama />} />
      <Route path="/convocatorias" element={<Convocatorias />} />
      <Route path="/manuales" element={<Manuales />} />

      {/* Rutas relacionadas con Producción */}
      <Route path="/:slug" element={<PaginaDinamica />} />

      <Route path="/noticias/:slug" element={<NewsDetail />} />

      {/* Ruta para páginas no encontradas */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRouter;
